import { useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '@web-common/state/createStore';
import { Thunks } from '@web-common/state/reducer/mailReducer';
import { isMainAccount, isAliasAccount, promiseIsTimeOut } from '@web-mail/util';
const useGetFolderTree = (_account) => {
    const dispatch = useAppDispatch();
    const treeList = useAppSelector(state => {
        var _a;
        if (!_account || isMainAccount(_account) || isAliasAccount(_account)) {
            return state.mailReducer.mailTreeStateMap.main.mailFolderTreeList;
        }
        return ((_a = state.mailReducer.mailTreeStateMap[_account]) === null || _a === void 0 ? void 0 : _a.mailFolderTreeList) || [];
    });
    const isFirst = useRef(true);
    useEffect(() => {
        if (isFirst.current && (!treeList || treeList.length === 0)) {
            isFirst.current = false;
            promiseIsTimeOut(dispatch(Thunks.refreshFolder({
                noCache: true,
            })), 'pc_refreshFolder_timeout', {
                from: 'useGetFolderTree',
            });
        }
    }, [treeList]);
    return treeList;
};
export default useGetFolderTree;
